<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
       
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
                        id="reasons_datatable">
                <thead class="mb-5">
                  <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                    <th class="min-w-100px text-center">{{ $t('pipelines.reasons') }}</th> 
                    <th class="min-w-100px text-center">{{ $t('pipelines.opportunity_number') }} </th>
                    <th class="min-w-100px text-center">{{ $t('pipelines.seller_number') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="topOpportunityLostReasons?.length > 0" v-for="(reason, index) in topOpportunityLostReasons" :key="index">
                    <td>{{ reason.reason }}</td>
                    <td>{{ reason.total }}</td>
                    <td>{{ reason.commercial_count }}</td>
                  </tr>
                  <tr v-else class="text-center justify-content-center">
                    <td colspan="3">
                      <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import Loader from '@/components/Loader.vue';
import {  watch, onMounted,  ref} from 'vue';


const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },


})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})

const online = ref(false)
const row = ref(0)
const column = ref(0)
const topOpportunityLostReasons = ref([])

watch(() => online.value, (value) => {
    query.value.status = value ? 'LOST' : 'WON'
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
          let answer = res?.response?.data || res?.data
          row.value = res.row
          column.value = res.column

          topOpportunityLostReasons.value = answer?.topOpportunityLostReasons


        })
    ]).then(() => {
    })
}

onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})
</script>